/*
    Class Collection
    It's a indexed Map!
*/
class Collection {

    constructor() {
        this.base = new Map();
        this.list = [];
        console.log(this[Symbol.iterator]);
        this[Symbol.iterator] = this.iterator;
    }

    iterator(startAt) {
        if (typeof startAt == "string") {
            startAt = this.list.indexOf(startAt);
        }
        let count = startAt || 0;
        return {
            next: () => {
                let result = count < this.list.length ? {
                    value: this.base.get(this.list[count++]),
                    done: false
                } : {
                    done: true
                };
                return result;
            },
            prev: () => {
                let result = count > 0 ? {
                    value: this.base.get(this.list[--count]),
                    done: false
                } : {
                    done: true
                };
                return result;
            }
        };
    }

    indexOf(key) {
        if (typeof key == "string") {
            return this.list.indexOf(key);
        }
        return key;
    }

    first() {
        return this.get('_first');
    }

    last() {
        return this.get('_last');
    }

    shift() {

    }

    get(key) {
        var index = this.getKeyIndex(key);
        if (index > this.list.length - 1) {
            index = this.list.length - 1;
        }
        if (index < 0) {
            index = 0;
        }
        return this.base.get(this.list[index]);
    }

    nextOf(key) {
        return this.get(this.indexOf(key) + 1);
    }

    prevOf(key) {
        return this.get(this.indexOf(key) - 1);
    }

    set(key, value) {
        if (this.list.indexOf(key) == -1) {
            this.base.set(key, value);
            this.list.push(key);
        }
    }

    getKeyIndex(_key) {
        var i = this.list.indexOf(_key);
        if (_key == "_first") i = 0;
        if (_key == "_last") i = this.list.length - 1;
        return i;
    }

    delete(_key) {
        var temp = this.get(_key);
        this.base.delete(this.list.splice(this.getKeyIndex(_key), 1).join(''));
        return temp;
    }

    forEach(callback) {
        this.base.forEach(callback);
    }

    get length() {
        return this.list.length;
    }

}
